<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconVideoSystems_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M10.947 3.061a2.763 2.763 0 1 1-5.527 0 2.763 2.763 0 0 1 5.527 0m-1.274 0a1.488 1.488 0 1 1-2.976 0 1.488 1.488 0 0 1 2.976 0M3.026 2.51h-.11A1.916 1.916 0 0 0 1 4.426v6.485c0 1.058.858 1.915 1.916 1.915h10.168A1.916 1.916 0 0 0 15 10.91V4.425a1.916 1.916 0 0 0-1.916-1.915h-.075l-.035-.001h-.368a.553.553 0 0 0 0 1.105h.17v.001h.308a.81.81 0 0 1 .81.81v6.485a.81.81 0 0 1-.81.81H2.916a.81.81 0 0 1-.81-.81V4.425a.81.81 0 0 1 .81-.81h.31v-.001h.537a.553.553 0 0 0 0-1.105zm2.948 11.053h4.052l.535 1.604a.46.46 0 0 1-.437.607H5.876a.46.46 0 0 1-.437-.607zm2.763-10.5a.553.553 0 1 1-1.105 0 .553.553 0 0 1 1.105 0m-4.62 1.657c.349 0 .66.207.855.497A3.87 3.87 0 0 0 8.185 6.93c1.39 0 2.609-.733 3.29-1.834a.76.76 0 0 1 .636-.377.68.68 0 0 1 .679.68v3.815a1.4 1.4 0 0 1-1.4 1.4H4.61a1.4 1.4 0 0 1-1.4-1.4v-3.59c0-.5.406-.905.906-.905"
        clip-rule="evenodd"
    />
</svg>
